import Vue from 'vue';
import VueRouter from 'vue-router';
import Site from './store/index';
import { GetCurrentUser } from './services/api';

Vue.use(VueRouter);
const router = new VueRouter({
  mode: 'history',
  routes: [
    /* eslint-disable global-require */
    {
      path: '/',
      component: require('./views/home.vue'),
      name: 'view-home',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    {
      path: '/video',
      component: require('./views/video-play.vue'),
      name: 'view-video',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    {
      path: '/upload_adder',
      component: require('./views/upload.vue'),
      name: 'view-upload',
      meta: {
        authenticated: true,
        adminOnly: false,
      },
    },
    {
      path: '/upload_success',
      component: require('./views/upload-success.vue'),
      name: 'view-upload-success',
      meta: {
        authenticated: true,
        adminOnly: false,
      },
    },
    {
      path: '/about',
      component: require('./views/about.vue'),
      name: 'view-about',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    {
      path: '/about_upload',
      component: require('./views/about-upload.vue'),
      name: 'view-about-upload',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    {
      path: '/login',
      component: require('./views/login.vue'),
      name: 'view-login',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    {
      path: '/register',
      component: require('./views/register.vue'),
      name: 'view-register',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    {
      path: '/password-reset',
      component: require('./views/password-reset.vue'),
      name: 'view-password-reset',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    {
      path: '/admin',
      component: require('./views/user-approval.vue'),
      name: 'view-user-approval',
      meta: {
        authenticated: true,
        adminOnly: true,
      },
    },
    {
      path: '*',
      component: require('./views/404.vue'),
      name: '404',
      meta: {
        authenticated: false,
        adminOnly: false,
      },
    },
    /* eslint-enable global-require */
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.authenticated || to.meta.adminOnly) {
    if (Site.getters.user) {
      if (to.meta.adminOnly) {
        return Site.getters.isAdmin ? next() : next({ name: 'view-home' });
      }
      return next();
    }
    GetCurrentUser().then((res) => {
      if (res.data) {
        Site.dispatch('setUser', res.data);
        if (to.meta.adminOnly) {
          return Site.getters.isAdmin ? next() : next({ name: 'view-home' });
        }
        return next();
      }
      return next({ name: 'view-login' });
    })
    .catch(() => next({ name: 'view-login' }));
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js